import { render } from "./PersonalInformation.vue?vue&type=template&id=665229f4"
import script from "./PersonalInformation.vue?vue&type=script&lang=js"
export * from "./PersonalInformation.vue?vue&type=script&lang=js"
script.render = render

export default script